// @license @preserve Copyright
/*
	The Life-Purpose Calculator was created by Martin Adams of Conscious Apps Inc.
	Copyright © 2010 - 2022 Conscious Apps Inc. All rights reserved.
	https://www.LifePurposeApp.com
	The Life-Purpose System is based on Dan Millman’s book, The Life You Were Born to Live.
	Text Copyright © 1993, 2018 Dan Millman. All rights reserved.
*/

// React
import React from 'react'
import reactDom from 'react-dom'
// Packages
import update from 'browser-update'
// Components
import App from './App'

update({
	required: {
		// Edge
		e: 15,
		// Firefox
		f: 50,
		// Opera
		o: 40,
		// Safari
		s: 10.1,
		// Chrome
		c: '50'
	},
	insecure: true
})

reactDom.render(<App />, document.querySelector('LifePurposeApp'))
